"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.history = void 0;

var _createBrowserHistory = _interopRequireDefault(require("history/createBrowserHistory"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORT / EXPORT --------------- ++++++++++ */


var history = (0, _createBrowserHistory.default)(); // add listener to history so that when we move from one page to another we scroll to the top (for UX)

exports.history = history;
history.listen(function (location, action) {
  // scrolling the app div because of fancy css stuff happening for modals and otherwise (else we would just scroll the document)
  window.scrollTo(0, 0);
});